import React from "react";

const FloatingChatButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1300,
        background: "#5335CA",
        color: "#fff",
        border: "none",
        borderRadius: "50%",
        width: 56,
        height: 56,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 28,
      }}
      aria-label="Open chat"
    >
      💬
    </button>
  );
};

export default FloatingChatButton;
